import React from "react";

import { userMeGet, userMePut } from "../../../../services/api/user.js";
import { useFormEngine } from "../../../../services/hooks/index.js";
import { onSuccessCallbacks } from "../../../../services/utils/index.js";
import { TextField } from "../../../shared/fields/index.js";
import { FormDialogTemplate } from "../../../shared/templates/index.js";
import formSchema from "./_form-schema.js";
import onLoadCallbacks from "./_on-load-callbacks.js";

const UserProfileNameFormDialog = React.memo(({ actions, callback }) => {
  const {
    form, setFieldValue, handleSubmit, isLoading, isError, errors, isOpen, handleClose, isFieldError, fieldErrorMessage,
  } = useFormEngine(actions, null, userMePut, userMeGet, { name: "" }, formSchema(), onSuccessCallbacks(callback), onLoadCallbacks);

  return (
    <FormDialogTemplate
      maxWidth="sm"
      isOpen={isOpen}
      onClose={handleClose}
      title="profile"
      isPaper
      isError={isError}
      errors={errors}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      body={(
        <TextField
          label="name_and_surname_or_nickname"
          fieldName="name"
          form={form}
          isFieldError={isFieldError}
          fieldErrorMessage={fieldErrorMessage}
          setFieldValue={setFieldValue}
        />
      )}
    />
  );
});

export default UserProfileNameFormDialog;
